import InfoVideoTitle from "./InfoVideoTitle";
export default InfoVideoTitle;
